import { render, staticRenderFns } from "./mediationFailTwo.vue?vue&type=template&id=2119136d&scoped=true"
import script from "./mediationFailTwo.vue?vue&type=script&lang=js"
export * from "./mediationFailTwo.vue?vue&type=script&lang=js"
import style0 from "./mediationFailTwo.vue?vue&type=style&index=0&id=2119136d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2119136d",
  null
  
)

export default component.exports